import React from "react";
import { Card } from "react-bootstrap";
import "./potval.scss";
import { Headings } from "../../atoms/Headings";
import { formattedDate } from "../../helpers/helpers";
const PotValue = (props) => {
  const { pot } = props.potValue;
  const potVal = Math.trunc(pot && pot.totalValue)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  var decimalValue = ((pot && pot.totalValue) % 1).toFixed(2).substring(2);

  return (
    <div className="pot-value mb-3 mb-md-0">
      <Headings title="Your total pot is..." />
      <Card className="card-pot-value mt-4">
        {/* <div className="d-sm-none d-md-block"> */}
        <span className={potVal.length > 4 ? "pot-val-small" : "pot-val"}>
          £{potVal}.
          <span className={potVal.length > 4 ? "subset-small" : "subset"}>
            {decimalValue}
          </span>
        </span>
        <p className="corrected-date">
          Correct as of {pot?.asOn ? formattedDate(pot?.asOn) : ""}
        </p>
        {/* </div> */}
        {/* <div className="d-none d-sm-block d-md-none">
          <CardWithButton
            potval={potVal}
            decimal={decimalValue}
            date={correctedDate}
          />
        </div> */}
      </Card>
    </div>
  );
};

export default PotValue;
